import {
  CompanyReportCategory,
  CompanyReportCategoryStatusStatusEnum,
} from '@shared/api/types';
import { z } from 'zod';
import { reportSlugs } from '../slugs';

export const reasonOptions = [
  {
    value: CompanyReportCategoryStatusStatusEnum['no_emissions'],
    label: 'No emissions to report',
  },
  {
    value: CompanyReportCategoryStatusStatusEnum['not_required'],
    label: 'Not required',
  },
  {
    value: CompanyReportCategoryStatusStatusEnum['not_supported'],
    label: 'Not supported by the platform',
  },
  {
    value: CompanyReportCategoryStatusStatusEnum['data_unavailable'],
    label: 'Data unavailable',
  },
];

export function createSchema(
  categories: readonly CompanyReportCategory[],
  statuses: string[]
) {
  return categories.reduce(
    (schema, item) =>
      schema.extend({
        [item.slug]: z.object({
          status: z.enum(statuses as [string, ...string[]], {
            required_error: 'Required',
            message: 'Please select a reason',
          }),
          activityType: z.string(),
        }),
      }),
    z.object({})
  );
}

export function createDefaultValues(
  categories: readonly CompanyReportCategory[]
) {
  return categories.reduce(
    (acc, activity) => {
      // Default to existing status
      let status = activity.status;

      // If the report category status is "included" but there is no data added, set to "no_emissions"
      // Don't include fuel and energy as it is disabled by default
      if (
        activity.slug !== reportSlugs.fuelAndEnergy &&
        activity.status === CompanyReportCategoryStatusStatusEnum.included &&
        !activity.hasActivityData
      ) {
        status = CompanyReportCategoryStatusStatusEnum.no_emissions;
      }

      acc[activity.slug] = {
        status,
        activityType: activity.slug,
      };

      return acc;
    },
    {} as Record<
      string,
      {
        status: string;
        activityType: string;
      }
    >
  );
}
